<template>
  <div class="chat-message">
    <form @submit.prevent="submit()">
      <messenger-menu :user="user"></messenger-menu>
      <div tabindex="-1" class="input-group input-group--focused input-group--dirty input-group--dark input-group--hide-details input-group--text-field input-group--single-line input-group--multi-line input-group--full-width">
        <div class="input-group__input">
          <textarea tabindex="0" rows="2" v-model="message" autofocus @keydown.enter.capture="submit"></textarea>
        </div>
      </div>
      <v-btn type="submit" icon :loading="loading">
        <v-icon>send</v-icon>
      </v-btn>
    </form>
  </div>
</template>

<script>
  import chatMessage from '@/mixins/chatMessage'
  import { TextInput } from '@/components/inputs'
  import MessengerMenu from './Menu.vue'
  export default {
    components: {
      MessengerMenu,
      TextInput
    },
    mixins: [chatMessage],
    props: {
      conversationId: {
        type: String
      }
    },
    data () {
      return {
        message: null
      }
    },
    methods: {
      submit (e) {
        if (e && e.shiftKey) return
        if (this.conversationId) {
          this.sendToConversation(this.conversationId, this.message)
            .then(message => {
              this.message = null
            })
        } else {
          this.send({ content: this.message })
            .then(message => {
              this.message = null
            })
        }
      }
    }
  }
</script>

<style scoped>
  form {
    display: flex;
  }
</style>

<style>
  .chat-message textarea {
    max-height: 200px;
    resize: none;
  }

  .chat-message .menu {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/MessageForm.vue